import { GRID_VERSION, createEmptyGrid } from './gridReducer'
import { loadJSON, saveJSON } from '../../utils/tabStorage'

// Versioned persistence for a grid. Layout is stored per browser tab (see
// tabStorage); a brand-new tab clones the last snapshot. Isolated here so a
// server-backed store can drop in later.
export function loadGrid(key) {
  if (!key) return createEmptyGrid()
  try {
    const parsed = loadJSON(key)
    if (parsed?.version !== GRID_VERSION || !Array.isArray(parsed.state?.columns)) {
      return createEmptyGrid()
    }
    return parsed.state
  } catch {
    return createEmptyGrid()
  }
}

export function saveGrid(key, state) {
  if (!key) return
  saveJSON(key, { version: GRID_VERSION, state })
}
